window.cartDrawer = window.cartDrawer || {};

/*============================================================================
  Override POST to cart/add.js. Returns cart JSON.
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
cartDrawer.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: $(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        cartDrawer.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        cartDrawer.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  $.ajax(params);
};

/*============================================================================
  Override POST to cart/change.js. Returns cart JSON.
    - Use product's line in the cart instead of ID so custom
      product properties are supported.
==============================================================================*/
cartDrawer.changeItem = function(line, quantity) {
  var deferred = $.Deferred();
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      deferred.resolve(cart);
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log(XMLHttpRequest, textStatus);
      deferred.reject();
    }
  };
  $.ajax(params)
  return deferred.promise();
};

/*============================================================================
  GET cart.js returns the cart in JSON.
==============================================================================*/
cartDrawer.getCart = function(_flg) {
  var deferred = $.Deferred();

  $.getJSON('/cart.js', function (cart, textStatus) {
    if (cart) {
      if(_flg){
        setTimeout(function(){
          $("html").addClass("cartOpen");
        }, 300);
      }
      deferred.resolve(cart);
    }
    else {
      deferred.reject();
    }
  });

	return deferred.promise();
};

cartDrawer.createItems = function(_cart) {
  var items = _cart.items;
  var itemLen = items.length;

  if(itemLen > 0){

    var template = $("#cartDrawerItems").html();
    // console.log(items)

    var src = ""
    var totalQuantity = 0;
    var totalPrice = 0;
    for(var i=0,len=items.length;i<len;i++){
      var $template = $( template );

      totalQuantity += items[i].quantity
      totalPrice += items[i].original_line_price;

      var pc_img = items[i].featured_image.url
      var sp_img = items[i].featured_image.url
      if(items[i].featured_image.url.indexOf("_trim.") != -1){
        pc_img = items[i].featured_image.url.replace("_trim.","_trim_100x100.")
        sp_img = items[i].featured_image.url.replace("_trim.","_trim_200x200.")
      }

      $template.find(".cartin-product-pic")
        .attr("href","/products/"+items[i].handle)
        .find("source")
        .attr("srcset",sp_img)
        
      $template.find(".cartin-product-pic")
        .find("img")
        .attr({
          "src": sp_img,
          "srcset": pc_img + " 1x,"+ sp_img +" 2x",
          "alt": items[i].featured_image.alt
        })

      $template.find(".cartin-product-title").html(items[i].title)

      if(items[i].variant_title){
        $template.find(".cartin-product-variation").html(items[i].variant_title)
      }else{
        $template.find(".cartin-product-variation").html("")
      }

      var price = theme.Currency.formatMoney(items[i].price, theme.moneyFormat)
      $template.find(".cartin-product-price").html(price)

      $template.find(".cartin-product-quantity-counter-add-num")
        .attr({
          "value": items[i].quantity,
          "data-line-no": i + 1
        })
        .val(items[i].quantity)
      // console.log($template.find(".cartin-product-quantity-add-counter-num")[0],items[i].quantity)

      var linePrice = theme.Currency.formatMoney(items[i].line_price, theme.moneyFormat)
      $template.find(".cartin-product-total-price").html(linePrice)

      $template
        .find(".cartin-delete-btn,.pcartin-product-quantity-add-counter-minus,cartin-product-quantity-add-counter-plus")
        .attr("data-line-no", i + 1)


      src += '<li>' + $template.html()+ '</li>'
    }
    var $src = $(src);

    //数を変更する
    $src.find(".cartin-product-quantity-counter-add-num").off("change").on("change", function(){
      var quantity = $(this).val();
      cartDrawer.changeItem($(this).data("line-no"), quantity).then(function(_cart){
        cartDrawer.createItems(_cart)
      })
    })


    // //１つ減らす
    // $src.find(".pcartin-product-quantity-add-counter-minus").off("click").on("click", function(){
    //   var quantity = $template.find(".cartin-product-quantity-counter-add-num").val() - 1;
    //   cartDrawer.changeItem($(this).data("line-no"), quantity).then(function(_cart){
    //     cartDrawer.createItems(_cart)
    //   })
    // })

    // //１つ増やす
    // $src.find(".pcartin-product-quantity-add-counter-plus").off("click").on("click", function(){
    //   var quantity = $template.find(".cartin-product-quantity-counter-add-num").val() + 1;
    //   cartDrawer.changeItem($(this).data("line-no"), quantity).then(function(_cart){
    //     cartDrawer.createItems(_cart)
    //   })
    // })

    //削除
    $src.find(".cartin-delete-btn").off("click").on("click", function(){
      cartDrawer.changeItem($(this).data("line-no"), 0).then(function(_cart){
        cartDrawer.createItems(_cart)
      })
    })

    //合計個数
    $(".sw-cp-header-cart-num, [data-cart-popup-cart-quantity]").html(totalQuantity)
    $("#CartCount [data-cart-count]").html(totalQuantity)
    
    //合計金額
    var totalPriceFormat = theme.Currency.formatMoney(totalPrice, theme.moneyFormat)
    $(".sw-cp-other-pricewrap-price").html(totalPriceFormat + "（税込）")

    $("#cartDrawerElm ul").empty().html($src)
  } else {
    $(".sw-cp-other-pricewrap-price").html("")
    $(".sw-cp-header-cart-num, [data-cart-popup-cart-quantity]").html(0)
    $("#CartCount").addClass("hide").find("[data-cart-count]").html(0)
    $("#cartDrawerElm ul").empty().html("<li>カート中身はありません。</li>")

  }
};


$().ready(function(){
  cartDrawer.getCart(false).then(function(_cart){
    cartDrawer.createItems(_cart)
  })

  //閉じるボタン
  $(".sw-cp-header-close-btn, .sw-cp-overlay, .sw-cp-other-close-text").on("click", function(){
    $("html").removeClass("cartOpen");

    $(".cart-popup-wrapper").addClass("cart-popup-wrapper--hidden")
  })
})